import React, { Component } from 'react'
import { connect } from 'react-redux'

// import components
import DWHouse from '../../shared/components/DWHouse'
import Header from '../../shared/components/Header'
import { hasSubscriptionPermission } from '../../utils/auth'
// import { translation } from '../../utils/helpers'

import './datawarehouse.scss'

class DataWarehouse extends Component {

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 30, 10)) return null

    // Get report type from url parameter or passed in reportType prop. (valid values: 0 = shop or 1 = chain)
    let reportType = this.props.params.reportType !== undefined ? this.props.params.reportType : this.props.reportType

    if (reportType === undefined || reportType === null) {
      console.error(`ReportType ${reportType} is invalid!`)
    }
    return (
      <div className='datawarehouse__screen'>
        <Header router={this.props.router} />
        <DWHouse reportType={reportType} />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { })(DataWarehouse)



// WEBPACK FOOTER //
// ./src/app/pages/DataWarehouse/index.js